import { render, staticRenderFns } from "./InputSuggestions.vue?vue&type=template&id=47da4fe6&"
import script from "./InputSuggestions.vue?vue&type=script&lang=ts&"
export * from "./InputSuggestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports